<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>李克强主持召开部分地方减税降费工作座谈会</h1>
        <h2><span class="mg-16">来源：新华社</span>|<span class="mg-16">发布时间：2020-03-30&nbsp;13:30</span></h2>
        <h3 class="title-two">
          <div>李克强在部分地方减税降费工作座谈会上强调</div>
          <div>以政府过紧日子确保减税降费到位</div>
          <div>更大激发市场活力更好保障基本民生</div>
        </h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest1" alt />
        </div>
        <h3>5月24日，中共中央政治局常委、国务院总理李克强在山东济南主持召开部分地方减税降费工作座谈会，部署进一步落实好减税降费各项政策。 庞兴雷 摄</h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest2" alt />
        </div>
        <h3>新华社北京7月10日电（记者 座谈会上，山东省委书记刘家义、省长龚正和河北省长许勤、江苏省长吴政隆、福建省长唐登杰、河南省长陈润儿、贵州省长谌贻琴发了言。大家反映，减税降费力度大、惠及面广，明显减轻了市场主体负担，个税改革增加了居民收入，发挥了稳预期、稳增长的重要作用。李克强与大家深入交流。</h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest3" alt />
        </div>
        <h3>李克强说，今年以来，我国经济发展面临的形势复杂严峻，虽然一季度开局良好，但经济平稳运行态势还不稳固，特别是面临不断增多的外部不确定因素和挑战。要坚持以习近平新时代中国特色社会主义思想为指导，抓紧落实党中央、国务院决策部署，统筹做好“六稳”工作，依靠改革开放更大激发实体经济活力、释放内需潜力、增强发展动力，战胜困难挑战，把我们自己的事办好，为实现比较充分的就业、经济平稳健康发展奠定更稳固基础。</h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest4" alt />
        </div>
        <h3>李克强指出，亿万市场主体是稳就业的“顶梁柱”、是增长的“发动机”，确保更大规模减税降费落实到位、激发市场主体活力，关系经济社会大局。一要算好当前账和长远账。减税降费虽然减少眼前财政收入，但会增强企业投资与发展的信心和动力，带动扩大就业，最终实现经济持续增长、税源不断扩大。必须上下同心把这件大事办成办好，确保所有行业税负只减不增，尤其是要确保农资价格稳定。二要算好中央账和地方账。为减税降费，中央财政做了充分准备，通过增加特定金融机构和央企利润上缴、加大对地方转移支付等多种措施，可以平衡全国收支大账。从地方看，也有条件克服困难，实现减税降费落地和财政收支平衡。各地要深挖潜力，通过盘活财政存量资金和政府存量资产、增加地方国企利润上缴等，做大可用财力“蛋糕”，支持减税降费，决不能搞变通靠增加企业负担来缓解财政收支压力。对实施中少数地方遇到的特殊困难，中央财政会统筹给予帮助。必须强调，各级政府过紧日子决不能说说而已，要在行政开支上打好“铁算盘”、当好“铁公鸡”，切实保障好“保工资、保运转、保基本民生”等支出，不该支出的钱一分也不能花，把节省下的资金用于支持重点建设和民生改善。</h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest5" alt />
        </div>
        <h3>李克强说，中国经济韧性很强，宏观调控仍有政策工具运用空间。当前要把已明确的更大规模减税降费政策实施好，下一步对制造业增值税留抵退税还要放宽条件、优化流程，并研究完善对企业研发创新的支持政策。各地区、各部门要跟踪分析经济运行情况和政策落实中遇到的问题，完善应对措施，把减税降费等政策红利转化为优化经济结构、扩大有效需求的动力，确保经济平稳运行、民生不断改善，在推动高质量发展上取得新成绩。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/B3-1.jpg"),
      PicBannertest2: require("../../../../assets/image/B3-2.jpg"),
      PicBannertest3: require("../../../../assets/image/B3-3.jpg"),
      PicBannertest4: require("../../../../assets/image/B3-4.jpg"),
      PicBannertest5: require("../../../../assets/image/B3-5.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
img{
  margin: 20px 0;
}
.title-two {
  text-align: center;
  font-weight: bold !important;
  margin-bottom: 0px!important;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>